import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  toggle() {
    const isOpen = this.sidebarTarget.classList.contains("courses-portal-sidebar--open")
    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.sidebarTarget.classList.add("courses-portal-sidebar--open")
    this.overlayTarget.classList.add("courses-portal-overlay--visible")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.sidebarTarget.classList.remove("courses-portal-sidebar--open")
    this.overlayTarget.classList.remove("courses-portal-overlay--visible")
    document.body.style.overflow = ""
  }
}
